import { render, staticRenderFns } from "./ObjectModal.vue?vue&type=template&id=5819c0cf&scoped=true"
import script from "./ObjectModal.vue?vue&type=script&lang=js"
export * from "./ObjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819c0cf",
  null
  
)

export default component.exports